// extracted by mini-css-extract-plugin
export default {"about":"About_about__tFYRZ","bio":"About_bio__Txnz4","skills":"About_skills__r8Qmm","skill":"About_skill__G00OU"};